import Route from '@ember/routing/route';
import { service } from '@ember/service';

import { findRecord } from 'umg-ember-backend/data/builders/umg-rest';

export default class AdminLivePartnersLivePartnerRoute extends Route {
  // Services
  @service breadcrumb;
  @service store;

  // Hooks
  async model({ live_partner_id }) {
    const { content } = await this.store.request(
      findRecord('live-partner', live_partner_id),
    );

    return content.data;
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
